// ? Build Command:  npm.cmd run-script build
// ? Start Command: npm.cmd run-script serve
// https://d2ky8yq8f4lgab.cloudfront.net/

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Components
import './components'

// Plugins
import './plugins'


import VuejsDialog from 'vuejs-dialog';
// import VuejsDialogMixin from 'vuejs-dialog/vuejs-dialog-mixin.min.js'; // only needed in custom components
// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

// import VuetifyDialog from 'vuetify-dialog'
// import 'vuetify-dialog/dist/vuetify-dialog.css'
// Vue.use(VuetifyDialog);


// import VuetifyDialog from 'vuetify-dialog';
// import 'vuetify-dialog/dist/vuetify-dialog.css';
// Vue.use(VuetifyDialog, {
//   // context,
//   // property,
//   confirm: {
//     actions: {
//       false: 'No',
//         true: {
//         text: 'Yes',
//           color: 'primary'
//       }
//     },
//     icon: false, // to disable icon just put false
//       width: 500
//   },
//   warning: {},
//   error: {},
//   prompt: {}
// });


import VModal from 'vue-js-modal'
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

// Sync router with store
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'
// import i18n from './i18n'
import router from './router'
import store from './store'

// Sync store with router
sync(store, router);

Vue.config.productionTip = false;

// https://github.com/cmp-cc/vue-cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
// set default config
VueCookies.config('7d');


// import axios from 'axios';
//
// Vue.prototype.$http = axios;
// // axios.interceptors.request.use(function (config) {
// //   // const token = store.getState().session.token;
// //   // config.headers['x-api-key'] = 'FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM';
// //
// //   return config;
// // });
// axios.defaults.headers.common['x-api-key'] = 'FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM';


// // ES Modules, e.g. transpiling with Babel
// import {CognitoAuth} from 'amazon-cognito-auth-js';
// var authData = {
//   ClientId : '4k4m16mv5dmvqerq8fkkbq8t4o', // Your client id here
//   AppWebDomain : 'localhost:8080',
//   TokenScopesArray : [], // e.g.['phone', 'email', 'profile','openid', 'aws.cognito.signin.user.admin'],
//   RedirectUriSignIn : '/',
//   RedirectUriSignOut : '/',
//   IdentityProvider : '', // e.g. 'Facebook',
//   UserPoolId : 'ap-northeast-2_0pTUjYHsm', // Your user pool id here
//   AdvancedSecurityDataCollectionFlag : 'true', // e.g. true
//   // Storage: '<TODO the storage object>' // OPTIONAL e.g. new CookieStorage(), to use the specified storage provided
// };
//
// var auth = new CognitoAuth(authData);
// auth.userhandler = {
//   onSuccess: function(result) {
//     alert("Sign in success");
//     // showSignedIn(result);
//   },
//     onFailure: function(err) {
//       alert("Error!" + err);
//     }
// };
// Vue.prototype.auth = auth;
//
// import Amplify, * as AmplifyModules from 'aws-amplify'
// import { AmplifyPlugin } from 'aws-amplify-vue'
// import awsconfig from './aws-exports'
// Amplify.configure(awsconfig)
// AmplifyModules.I18n.setLanguage('ko')
// const dict = {
//   'ko': {
//     'Sign in to your account': '로그인하십시오.',
//   },
//   'fr': {
//     'Sign In': 'Se connecter',
//     'Sign Up': "S'inscrire",
//   },
//   'es': {
//     'Sign In': 'Registrarse',
//     'Sign Up': 'Regístrate'
//   }
// }
// AmplifyModules.I18n.putVocabularies(dict)
//
// // // import Amplify, * as AmplifyModules from 'aws-amplify'
// // // import AmplifyPlugin from 'aws-amplify-vue'
// // import AwsExports from './aws-exports'
// // import SignIn from 'aws-amplify-vue/src/components/authenticator/SignIn.vue'
// // import SignUp from 'aws-amplify-vue/src/components/authenticator/SignUp.vue'
// // import SignOut from 'aws-amplify-vue/src/components/authenticator/SignOut.vue'
// // import ConfirmSignUp from 'aws-amplify-vue/src/components/authenticator/ConfirmSignUp.vue'
// // import ConfirmSignIn from 'aws-amplify-vue/src/components/authenticator/ConfirmSignIn.vue'
// // import ForgotPassword from 'aws-amplify-vue/src/components/authenticator/ForgotPassword.vue'
// // import Authenticator from 'aws-amplify-vue/src/components/authenticator/Authenticator.vue'
// // import SetMfa from 'aws-amplify-vue/src/components/authenticator/SetMFA.vue'
// // import RequireNewPassword from 'aws-amplify-vue/src/components/authenticator/RequireNewPassword.vue'
// // import UsernameField from 'aws-amplify-vue/src/components/authenticator/UsernameField'
// //
// // Amplify.configure(AwsExports)
// //
// // Vue.prototype.$Amplify = Amplify
// // Vue.use(AmplifyPlugin, AmplifyModules)
// //
// // Vue.mixin({
// //   components: {
// //     amplifyUsernameField: UsernameField,
// //     amplifySignIn: SignIn,
// //     amplifySignUp: SignUp,
// //     amplifySignOut: SignOut,
// //     amplifyConfirmSignUp: ConfirmSignUp,
// //     amplifyConfirmSignIn: ConfirmSignIn,
// //     amplifyForgotPassword: ForgotPassword,
// //     amplifyAuthenticator: Authenticator,
// //     amplifySetMfa: SetMfa,
// //     amplifyRequireNewPassword: RequireNewPassword
// //   }
// // })
//
// Vue.use(AmplifyPlugin, AmplifyModules)


/* eslint-disable no-new */
new Vue({
  // i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');


